import { useCallback } from 'react'
import { ActivityData, NotificationData } from '../interfaces/Notifications'
import {
  useInfiniteLoadByOffset,
  InfiniteLoadByOffsetProps,
  InfiniteLoadByOffsetReturn,
} from './infiniteLoadByOffset'

type InfiniteLoadNotificationReturn<T, RawT> = InfiniteLoadByOffsetReturn<T, RawT> & {
  seenItem: (group: string) => void
}

export function useInfiniteLoadNotification<T extends NotificationData, RawT extends ActivityData>(
  props: InfiniteLoadByOffsetProps<T>
): InfiniteLoadNotificationReturn<T, RawT> {
  const { getItems, onNextItems, refetchMarker, page_size } = props
  const {
    rawData,
    data,
    error,
    setData,
    fetchNext,
    hasNext,
    refetch,
    isLoading,
    nextIsLoading,
    isRefetching,
  } = useInfiniteLoadByOffset<T, RawT>({
    id: props.id,
    getItems,
    page_size,
    onNextItems,
    refetchMarker,
  })

  const seenItem = useCallback(
    (group: string): void => {
      const newItems = data.map((item) => {
        if (item.activity.group === group) {
          return { ...item, activity: { ...item.activity, is_group_seen: true } }
        }
        return item
      })
      setData(newItems)
    },
    [data, setData]
  )

  return {
    rawData,
    data,
    error,
    setData,
    fetchNext,
    hasNext,
    refetch,
    isLoading,
    nextIsLoading,
    isRefetching,
    seenItem,
  }
}
